/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import "./_metronic/assets/sass/style.scss";
import "./_metronic/assets/sass/plugins.scss";
import "./_metronic/assets/sass/style.react.scss";

import * as Sentry from "@sentry/react";
// Axios
import axios from "axios";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";

// Apps
// import { LangProvider } from "./app/contexts/lang/LangContext18n";
import { UserProvider } from "./app/contexts/userContext";
import { AppRoutes } from "./app/routing/AppRoutes";
/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      cacheTime: 0,
      keepPreviousData: true,
      retry: false,
    },
  },
});

Sentry.init({
  dsn: "https://e21b03d8680f861c332fb8b76798df74@o4507017865592832.ingest.us.sentry.io/4507073166704640",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  environment: process.env.REACT_APP_WEB_ENV,
  enabled: process.env.NODE_ENV !== "development",
});

const container = document.getElementById("root");
if (container) {
  createRoot(container).render(
    <Sentry.ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        {/* <LangProvider> */}
        <UserProvider>
          <AppRoutes />
        </UserProvider>
        {/* </LangProvider> */}
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </Sentry.ErrorBoundary>,
  );
}
